import { Container, Row, Col,} from "react-bootstrap";
import { PostData } from "./post-data";
import { HoverCard } from "../../../common/hover-cards/HoverCards";
import { ArrowPointer } from "../../../common/navigating-arrow/ArrowPointer";


export const PostWithPamo = () => {
  return (
    <Container fluid className="post-with-pamo">
      <div className="tutorial-parent-header">
        <p className="tutorial-header-text fw-bold text-center my-5"
        data-aos="fade-down"
        data-aos-easing="linear"
        data-aos-duration="500"
        data-aos-once="false"
        >
        Find Your Perfect Match: Post with Pamo!
        </p>
      </div>
      <div className="tutorial-card-container d-flex flex-nowrap overflow-auto">
        {PostData.map((data, key) => (
          <div key={key} className="mx-3 my-5">
            <HoverCard data={data} />
          </div>
        ))}
      </div>  
      <ArrowPointer/>

    </Container>
  );
};
